import React, { Fragment } from 'react';
import {
  // NOTIFICATION_PATH,
  PAYMENTS_PATH,
  DOCUMENTS_PATH,
  REQUESTS_PATH,
  DASHBOARD_PATH,
  PAGE_NOT_FOUND_PATH,
  USERS_ROUTE_PATH,
  PROFILE_PATH,
  UPLOADDOCUMENT_PATH,
  CUSTOMERS_ROUTE_PATH,
  DOCUMENT_EDIT_PATH,
  VIEW_CUSTOMER_PATH,
  AGENCY_PROFILE_PATH,
  AGENCY_INSTRUCTIONS_PAGE,
  AGENCY_INVOICE_PAGE,
  AGENCY_NEWINVOICE_PAGE,
  AGENCY_CUSTOMER_PAGE,
  AGENCY_CUSTOMER_NEW_PAGE,
  AGENCY_CUSTOMER_EDIT_PAGE,
  AGENCY_COUPONS_PAGE,
  AGENCY_COUPONS_NEW_PAGE,
  AGENCY_COUPONS_EDIT_PAGE,
  AGENCY_SUBSCRIPTIONS_PAGE,
  AGENCY_SUBSCRIPTIONS_NEW_PAGE,
  AGENCY_SUBSCRIPTIONS_EDIT_PAGE,
  AGENCY_VIEW_INVOICE,
  AGENCY_REPORT_PAGE,
  WEBFORM_USER_REPORT,
} from '../../utils/AppRoutes';
import { Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import Dashboard from '../dashboard/index.jsx';
import Payments from '../payments/index.jsx';
import Documents from '../documents/index.jsx';
import Users from '../users/index.jsx';
import Requests from '../requests/index.jsx';
import Profile from '../profile/index.jsx';
import Customers from '../customers';
import View from '../customers/view';
import CreateDocument from '../documents/createDocument';
import CustomPageNotFound from '../common/CustomPageNotFound';
import AgencyProfile from '../profile/AgencyProfile';
import Instructions from '../documents/instructions/Instructions';
import NewInvoice from '../admin/invoice/NewInvoice';
import Coupons from '../admin/invoice/Coupons';
import NewCoupons from '../admin/invoice/NewCoupons';
import NewCustomer from '../admin/invoice/NewCustomer';
import Customer from '../admin/invoice/Customer';
import Subscriptions from '../admin/invoice/Subscriptions';
import NewSubscriptions from '../admin/invoice/NewSubscriptions';
import InvoiceList from '../admin/invoice/InvoiceList';
import ViewInvoice from '../admin/invoice/ViewInvoice';
import Reports from '../reports/Reports';
import UserReports from '../reports/UserReports';

const AppLayout = () => {
  return (
    <Fragment>
      {/* Header  */}
      <Header />
      {/* Header  */}

      {/* Sidebar  */}
      <Sidebar />
      {/* Sidebar  */}

      <div className="admin-body">
        <Container>
          <Switch>
            <Route exact path={DASHBOARD_PATH} component={Dashboard} />
            <Route
              exact
              path={AGENCY_INSTRUCTIONS_PAGE}
              component={Instructions}
            />
            <Route exact path={REQUESTS_PATH} component={Requests} />
            <Route exact path={USERS_ROUTE_PATH} component={Users} />
            <Route exact path={CUSTOMERS_ROUTE_PATH} component={Customers} />
            <Route
              exact
              path={VIEW_CUSTOMER_PATH + '/:email'}
              component={View}
            />
            <Route exact path={PAYMENTS_PATH} component={Payments} />
            <Route exact path={PROFILE_PATH} component={Profile} />
            <Route exact path={AGENCY_PROFILE_PATH} component={AgencyProfile} />
            <Route
              exact
              path={UPLOADDOCUMENT_PATH}
              component={CreateDocument}
            />
            <Route exact path={DOCUMENTS_PATH} component={Documents} />
            <Route path={DOCUMENT_EDIT_PATH} component={CreateDocument} />
            <Route exact path={AGENCY_INVOICE_PAGE} component={InvoiceList} />
            <Route path={AGENCY_NEWINVOICE_PAGE} component={NewInvoice} />
            <Route exact path={AGENCY_VIEW_INVOICE} component={ViewInvoice} />
            <Route exact path={AGENCY_CUSTOMER_PAGE} component={Customer} />
            <Route exact path={AGENCY_REPORT_PAGE} component={Reports} />
            <Route exact path={WEBFORM_USER_REPORT} component={UserReports} />
            <Route
              exact
              path={AGENCY_SUBSCRIPTIONS_PAGE}
              component={Subscriptions}
            />
            <Route
              exact
              path={AGENCY_CUSTOMER_NEW_PAGE}
              component={NewCustomer}
            />
            <Route
              exact
              path={AGENCY_SUBSCRIPTIONS_NEW_PAGE}
              component={NewSubscriptions}
            />
            <Route
              exact
              path={AGENCY_CUSTOMER_EDIT_PAGE + '/:id'}
              component={NewCustomer}
            />
            <Route
              exact
              path={AGENCY_SUBSCRIPTIONS_EDIT_PAGE + '/:id'}
              component={NewSubscriptions}
            />
            <Route exact path={AGENCY_COUPONS_PAGE} component={Coupons} />
            <Route
              exact
              path={AGENCY_COUPONS_NEW_PAGE}
              component={NewCoupons}
            />
            <Route
              exact
              path={AGENCY_COUPONS_EDIT_PAGE + '/:id'}
              component={NewCoupons}
            />
            <Route path={PAGE_NOT_FOUND_PATH} component={CustomPageNotFound} />
          </Switch>
        </Container>
      </div>
    </Fragment>
  );
};
export default AppLayout;
